module.exports = __webpack_public_path__ + "img/endPage.26647313.png";